<template>
  <InactiveScreen v-if="getGameState == 'inactive'" />
  <EnterCodeScreen v-if="getGameState == 'entercode'" />
  <StartScreen v-if="getGameState == 'active' && getPlayerState == 'start'" />
  <PollScreen v-if="getGameState == 'active' && getPlayerState == 'poll'" />
  <UpdateDataScreen
    v-if="getGameState == 'active' && getPlayerState == 'update'"
  />
  <ShowDataScreen v-if="getGameState == 'active' && getPlayerState == 'show'" />
</template>

<script>
import InactiveScreen from "@/components/InactiveScreen.vue";
import EnterCodeScreen from "@/components/EnterCodeScreen.vue";
import StartScreen from "@/components/StartScreen.vue";
import PollScreen from "@/components/PollScreen.vue";
import UpdateDataScreen from "@/components/UpdateDataScreen.vue";
import ShowDataScreen from "@/components/ShowDataScreen.vue";

export default {
  name: "GameView",
  components: {
    InactiveScreen,
    EnterCodeScreen,
    StartScreen,
    PollScreen,
    UpdateDataScreen,
    ShowDataScreen,
  },
  computed: {
    getGameState: function () {
      return this.$store.getters.getGameState;
    },
    getPlayerState: function () {
      return this.$store.getters.getPlayerState;
    },
  },
  created() {
    this.$store.commit("setGameState", "inactive");
  },
  methods: {},
};
</script>

<style>
h1 {
  font-size: 120px;
  color: #fff;
  padding-bottom: 20px;
}
img {
  padding-bottom: 20px;
}
.outer {
  display: flex;
  align-items: center;
}
.center {
  margin: auto;
  padding: 10px;
}
.screen {
  /* background: url("~@/assets/home_bg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%; */
  overflow: hidden; /* Hide scrollbars */
}
.home-featured {
  background-color: #7b64bd;
  background-size: 600% 600%;
  -webkit-animation: gradanimate 0.5s ease infinite;
  animation: gradanimate 10s ease infinite;
}
@-webkit-keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
@keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
</style>
